import React, { Suspense, lazy } from "react";
import { Navigate } from "react-router";
import WorkspaceApp, { WorkspaceHome, ProgramHome } from "./WorkspaceApp";

// ProjectView and ArtifactView are loaded lazily so their ChatSession /
// canvas dependency chains aren't pulled into the initial bundle (or into
// unit tests that just import the route table).
const LazyProjectView = lazy(() => import("./ProjectView"));
const LazyArtifactView = lazy(() => import("./ArtifactView"));
const LazyABCompare = lazy(() => import("./ABCompare"));

const projectElement = (
  <Suspense fallback={<div data-testid="v2-project-loading">Loading project…</div>}>
    <LazyProjectView />
  </Suspense>
);

const artifactElement = (
  <Suspense fallback={<div data-testid="v2-artifact-loading">Loading artifact…</div>}>
    <LazyArtifactView />
  </Suspense>
);

const abElement = (
  <Suspense fallback={<div data-testid="v2-ab-loading">Loading A/B…</div>}>
    <LazyABCompare />
  </Suspense>
);

export const V2_PATHS = {
  ROOT: "v2",
  PROGRAM: "p/:program",
  PROJECT: "p/:program/:project",
  CHAT: "p/:program/:project/c/:chatId",
  ARTIFACT: "a/:artifactId",
  AB: "ab",
};

export const buildV2Route = (withV2) => {
  if (!withV2) {
    return {
      path: V2_PATHS.ROOT,
      element: <Navigate to="/" replace />,
    };
  }
  return {
    path: V2_PATHS.ROOT,
    element: <WorkspaceApp />,
    children: [
      { index: true, element: <WorkspaceHome /> },
      { path: V2_PATHS.PROGRAM, element: <ProgramHome /> },
      { path: V2_PATHS.PROJECT, element: projectElement },
      { path: V2_PATHS.CHAT, element: projectElement },
      { path: V2_PATHS.AB, element: abElement },
    ],
  };
};

export const buildV2ArtifactRoute = (withV2) => {
  if (!withV2) {
    return {
      path: V2_PATHS.ARTIFACT,
      element: <Navigate to="/" replace />,
    };
  }
  return {
    path: V2_PATHS.ARTIFACT,
    element: artifactElement,
  };
};
